<template>
  <div class="shipment text_left">
    <div class="margin_title_top">
      <div class="font_bold scanned_title">
        {{ $t("trackPay.contractsStartShipment.TrackersScanned") }}
      </div>
      <div
          v-for="(item, index) in scannedList"
          class="flex scanned_item"
          :key="index"
          @click="changeItem(item)"
      >
        <span class="accent_color margin_r scann_name">{{ item.id }}</span>
      </div>
    </div>
    <div class="head_tip">
      <div class="tip_content">
        <div>
          {{ $t("trackPay.contractsStartShipment.tip1") }}
        </div>
        <div class="margin_title_top">
          {{ $t("trackPay.contractsStartShipment.tip2") }}
        </div>
        <div class="flex flex_between">
          <span class="font_bold">
            {{ $t("trackPay.contractsStartShipment.tip3") }}
          </span>
          <!-- :logoSrc="config.logo" -->
          <vue-qr
              id="codeImg"
              style="text-align: center"
              :text="config.value"
              :size="200"
              :margin="0"
          ></vue-qr>
          <!-- <img src="@/assets/img/trackPay/trackPay.png" alt="" /> -->
        </div>
      </div>
    </div>

    <div class="flex flex_between margin_top">
      <!-- <md-button class="md-blank" @click="close">{{
        $t("common.button.cancel")
      }}</md-button>
      <md-button @click="start" class="md-primary" :class="{ 'md-primary': isFormValid }"
        >{{ $t("signUpBar.start") }}
      </md-button> -->
      <div></div>
      <md-button class="md-blank" @click="close">{{
          $t("common.button.close")
        }}
      </md-button>
    </div>
  </div>
</template>
<script>
import VueQr from "vue-qr";

export default {
  components: {
    VueQr,
  },
  props: {
    contractData: Object
  },
  data() {
    return {
      scannedList: this.contractData.shipment.devices,
      config: {
        value: " "
      }
    };
  },
  mounted() {
    this.changeItem(this.scannedList[0]);
  },
  methods: {
    start() {
      this.$emit("start", "start");
    },
    close() {
      this.$emit("close");
    },
    changeItem(item) {
      this.config.value = item.id;
    }
  }
};
</script>
<style lang="scss" scoped>
.shipment {
  width: 500px;
  margin: auto;

  .head_tip {
    padding: 20px;
    text-align: left;
    background-color: #cbe9fe;
    width: 100%;

    .tip_content {
      width: 100%;
    }
  }

  .fa {
    margin-right: 10px;
  }

  .scanned_title {
    margin-bottom: 10px;
  }

  .scanned_item {
    margin-bottom: 5px;
  }

  .scann_name {
    cursor: pointer;
  }
}
</style>
